import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, viewChild, ViewChild} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import { MatDialog } from '@angular/material/dialog';
import { isNullOrUndef } from '../../../../common';
import {StoreSelectorsService} from "../../../../services";
import {SceneEffects} from "../../scene-blocks/block-constants";
import {BlockBaseComponent} from "../../scene-blocks/block-base/block-base.component";
import {actionCRUDScene, actionRemoveInSceneItem} from "../../../../store/actions/user.actions";
import {IAppearance, IBackground, IBlur, IBorder, IEffectName, IEffectTypeAny, IGlow, IGradient, IShadow} from "../../../../interfaces";

import * as _ from "lodash";
import { MatExpansionPanel, MatAccordion } from '@angular/material/expansion';
import {AiService} from "../../../../services/ai/ai.service";

@Component({
    selector: 'app-block-effect-group',
    templateUrl: './block-effect-group.component.html',
    styleUrls: ['./block-effect-group.component.scss']
})

export class BlockEffectGroupComponent extends BlockBaseComponent {

    // @ViewChild("effectAccordion") effectAccordion: MatAccordion;
    accordion = viewChild.required(MatAccordion);

    readonly sceneEffects = SceneEffects;

    effectShadow: IShadow = {alpha: '1', angle: '2', blur: '2', color: '8421504', distance: '10', resolution: '1', blurX: '11', blurY: '11', strength: '100'};
    effectBlur: IBlur = {blurX: '2', blurY: '2', resolution: '1'};
    effectBorder: IBorder = {cornerRadius: '1', borderThickness: '1', borderColor: '65535'};
    effectGradient: IGradient = {color0: '1', alpha0: '1', color1: '#2222f1', alpha1: '1', color2: '#689c3e', alpha2: '1', color3: '#ed3300', alpha3: '1'};
    effectAppearance: IAppearance = {alpha: '1', blendMode: 'normal'};
    effectGlow: IGlow = {alpha: '0.94', color: '255', blur: '10', resolution: '0.4', blurX: '11', blurY: '0', strength: '0'};
    effectBackground: IBackground = {color: '54015', alpha: '1', style: ''};

    existedEffects = {};
    openedEffects = {};

    constructor(
        public override storeSelector: StoreSelectorsService,
        public override dialog: MatDialog,
        //public aiService: AiService
    ) {
        super(storeSelector);
        /* alon
        this.aiService.addEffect$.subscribe( effectName => {
            debugger;
            this.addEffect(effectName);
        });

        this.aiService.removeEffect$.subscribe( effectName => {
            debugger;
            this.removeEffect(effectName);
        });

         */
    }

    override preInit() {
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        if (this.sceneItemSwitched) {
            this.accordion().closeAll();
            this.existedEffects = {};
            this.openedEffects = {};
        }
        this.checkEffectsExistInStore();
        super.componentStoreUpdates();
    }

    toggleEffect(checked, effectName, effectPanel: MatExpansionPanel) {
        if (checked) {
            this.addEffect(effectName);
            this.existedEffects[effectName] = true;
            setTimeout(() => {
                if (effectPanel) {
                    effectPanel.open();
                }
            }, 100);
        } else {
            this.removeEffect(effectName);
            this.existedEffects[effectName] = false;
            if (effectPanel) {
                effectPanel.close();
            }
        }
    }

    addEffect(effectName) {
        let defaultEffect;
        switch (effectName) {
            case "Appearance": {
                defaultEffect = this.effectAppearance;
                break;
            }
            case "Background": {
                defaultEffect = this.effectBackground;
                break;
            }
            case "Blur": {
                defaultEffect = this.effectBlur;
                break;
            }
            case "Shadow": {
                defaultEffect = this.effectShadow;
                break;
            }
            case "Border": {
                defaultEffect = this.effectBorder;
                break;
            }
            case "Gradient": {
                defaultEffect = this.effectGradient;
                break;
            }
            case "Glow": {
                defaultEffect = this.effectGlow;
                break;
            }
        }

        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: effectName,
                value: [{
                    $: defaultEffect
                }],
                storePath: 'Data[0]',
            }]
        });
    }

    removeEffect(effectName) {
        this.storeSelector.dispatch(actionRemoveInSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: effectName,
                value: null,
                storePath: 'Data[0]'
            }]
        }));
    }

    panelOpened(effectName, status) {
        this.openedEffects[effectName] = status;
    }

    private checkEffectsExistInStore() {
        SceneEffects.map((_effect) => {
            const effectStorePath = `Data[0].${_effect.name}[0]`;
            const effectSlice = _.get(this.sceneItem, effectStorePath);
            this.existedEffects[_effect.name] = !isNullOrUndef(effectSlice);
        });
        if (this.openedEffects['Background'] && !this.existedEffects['Background']) {
            this.accordion().closeAll();
        }
    }

    override destroy() {
        super.destroy();
        this.storeSelector.dispatch(actionCRUDScene({
            data: null
        }));
    }

}
